import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useMutation } from "@tanstack/react-query";
import { useContext, useState } from "react";
import Typography from "@mui/material/Typography";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { filterParams, selectedPracticesListState } from "../../state";
import { closeSelectedPractices } from "../../services/http.services";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import CustomLoader from "../../../../util/component/CustomLoader";
import ExpiredCustomDialog from "../../common/dialog/ExpiredCustomDialog";

const ClosePracticeButton = () => {

    const {t} = useTranslation("expiredManagement");
    const { dispatchGlobalData } = useContext(GlobalContext);
    const selectedPractices = useRecoilValue(selectedPracticesListState);
    const setExpiredPracticesFilter = useSetRecoilState(filterParams);

    const [openModal, setOpenModal] = useState(false);

    const closeSelectedPracticesMutation = useMutation({
        mutationFn: (request: string[]) => {
            return closeSelectedPractices(request);
        },
        onSuccess: () => {

            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t('common.message.success'),
                        type: snackbarTypes.success,
                        show: true,
                        autoClose: true,
                    }
                }
            });

            //Trigger search with current filters
            setExpiredPracticesFilter(((prev: any) => {
                return {...prev};
            }));

        },
        onError: (error: any) => {

            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t(`common.message.error.close.${error?.response?.status}`, t('common.message.error.tryLater')),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
        }
    });

    const onConfirm = () => {
        if (!!selectedPractices && selectedPractices.length > 0) {
            closeSelectedPracticesMutation.mutate(selectedPractices.map((x:any) => x.expiredCode));
            setOpenModal(false);
        }
    }

    return(
        <>
            <Button 
                disabled={!selectedPractices || selectedPractices.length <= 0}
                onClick={() => setOpenModal(true)}
            >
                {t('closeExpired.button.closeExpired')}
            </Button>

            <ExpiredCustomDialog 
                open={openModal}
                contentDescription={
                    <Typography color="primary" variant="body1">
                        {t('closeExpired.dialog.message')}
                    </Typography>

                }

                buttonCloseDescription={t('common.button.cancel')}
                buttonConfirmDescription={t('common.button.confirm')}
                onClose={() => setOpenModal(false)}
                onConfirm={onConfirm} 
            />
            
            <CustomLoader loading={closeSelectedPracticesMutation.isLoading}/>
        </>
    )

}

export default ClosePracticeButton;